import { render } from "./Group.vue?vue&type=template&id=0dc30dc8&scoped=true&ts=true"
import script from "./Group.vue?vue&type=script&setup=true&lang=ts"
export * from "./Group.vue?vue&type=script&setup=true&lang=ts"

import "./Group.vue?vue&type=style&index=0&id=0dc30dc8&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc30dc8"],['__file',"src/views/friend/Group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dc30dc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dc30dc8', __exports__)) {
    console.log('reload')
    api.reload('0dc30dc8', __exports__)
  }
  
  module.hot.accept("./Group.vue?vue&type=template&id=0dc30dc8&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0dc30dc8', render)
  })

}


export default __exports__